import { render } from "./FilterIndikatorGroupPriceRange.vue?vue&type=template&id=4d8cb416&ts=true"
import script from "./FilterIndikatorGroupPriceRange.vue?vue&type=script&lang=ts"
export * from "./FilterIndikatorGroupPriceRange.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__